import { Button, Menu, MenuItem } from "@mui/material";
import IosShareIcon from '@mui/icons-material/IosShare';
import { useMemo, useState } from "react";
import DialogProcessoExportar from "./DialogProcessoExportar";

export default function BtnExportarDados({
    pathRequisicao = "",
    fileName,
    formatos,
    cabecalhoLabels,
    queryParams = {},
    dadosArray = [],
    possuiQuery = false,
    disabled = false,
    tipoExportacao,
    exportTitle,
    exportInfo
}: BtnExportarDadosProps) {

    const [openModal, setOpenModal] = useState<TOpenModal | null>(null)
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const openMenu = Boolean(anchorEl);

    //funções manipuladoras
    const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleChangeModal = (value: TOpenModal | null) => {
        setOpenModal(value);
    };
    //

    useMemo(() => {
        if (tipoExportacao.length === 1 && openMenu) {
            handleChangeModal(tipoExportacao[0])
        }
    }, [tipoExportacao, openMenu])

    return (
        <>
            <Button
                {...{disabled}}
                size="small"
                variant="outlined"
                startIcon={<IosShareIcon />}
                id="basic-button"
                aria-controls={openMenu ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openMenu ? 'true' : undefined}
                onClick={handleClickMenu}
            >
                Exportar
            </Button>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={tipoExportacao.length > 1 ? openMenu : false}
                onClose={handleCloseMenu}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {
                    tipoExportacao && tipoExportacao.length > 1 &&
                    tipoExportacao.map((exportType, index) => (
                        <MenuItem key={index} onClick={() => handleChangeModal(exportType)}>
                            {`.${exportType}`}
                        </MenuItem>
                    ))
                }
            </Menu>

            {
                openModal &&
                <DialogProcessoExportar
                    {...{ fileName, pathRequisicao, queryParams, formatos, cabecalhoLabels, possuiQuery, dadosArray, tipoExportacao, exportTitle, exportInfo }}
                    open={Boolean(openModal)}
                    exportType={openModal}
                    handleClose={() => handleChangeModal(null)}
                />
            }
        </>
    )
}


export interface BtnExportarDadosProps {
    tipoExportacao: TOpenModal[]
    possuiQuery?: boolean
    dadosArray?: any[];
    pathRequisicao?: string,
    fileName: string,
    queryParams?: IQueryParams,
    cabecalhoLabels?: Array<{ queryKey: string; label: string; tipo?: "data" | "monetario" | "afirmacao/negacao" | "texto" }>,
    formatos?: { [key: string]: string }
    disabled?: boolean
    exportTitle?: string
    exportInfo?: Array<{ label: string; value: string }>
}

export type TOpenModal = "csv" | "pdf"
interface IQueryParams {
    [key: string]: any;
}